<modal-component>

	<!-- LEFT-->
	<div class="_header" left>
		<p class="_title" [translate]="'DEVICES_IMPORT.IMPORT'"></p>
		<p class="_subtitle" [translate]="'DEVICES_IMPORT.SUBTITLE'"></p>
	</div>

	<div class="_info" left>
		
		<div class="_step" *ngFor="let step of [1, 2, 3]">
			<div class="_step-number">
				<p>{{step}}</p>
			</div>
			<div class="_step-info">
				<p class="_step-info-title">
					{{'DEVICES_IMPORT.STEP_' + step + '.TITLE' | translate}}
				</p>
				<p class="_step-info-explanation">
					{{'DEVICES_IMPORT.STEP_' + step + '.SUBTITLE' | translate}}
				</p>
			</div>
		</div>

	</div>
	
	<!-- RIGHT -->
	<ng-container right>
		<div class="_upload-container">
			<span (click)="downloadImportTemplate()" class="_download-template-link">{{ 'DEVICES_IMPORT.DOWNLOAD' | translate}}</span>
			<input name="file" id="file" type="file" class="file-input" accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' (change)="uploadDevicesExcel($event)" label="SELECTEREN">
		</div>

		<div class="_found-devices-container"  *ngIf="showPreview">

			<p class="_found-devices-title">{{'DEVICES_IMPORT.IMPORTED_DEVICES' | translate}}: {{devices?.length || 0}}</p>
			<div class="_devices-container">
				<div class="_device-container" *ngFor="let device of devices; let i = index" [ngClass]="{'_offset': i % 2 === 0}">
					<div class="_device">
						<p class="_device-info">{{device.DeviceType.name}} ({{device.serial}})</p>
						<p class="_device-description" *ngIf="device.description">{{device.description}}</p>
					</div>
					<div class="_device-actions">
						<ion-icon src="./assets/icons/trash-outline.svg" (click)="removeDeviceFromImport(device)"></ion-icon>
					</div>
				</div>
			</div>

		</div>

	</ng-container>
	
	<!-- BUTTONS -->
	<ng-container buttons>
		<button *ngIf="showPreview" class="_button _save-button" [translate]="'DEVICES_IMPORT.IMPORT'" (click)="importDevices()"></button>
		<button *ngIf="!showPreview" disabled class="_button _save-button" [translate]="'DEVICES_IMPORT.IMPORT'" (click)="importDevices()" title="Je moet eerst een bestand selecteren."></button>
	</ng-container>


</modal-component>